// import _ from 'lodash';

const dealBuilder = {
  loading: true,
  isDealAvailable: false,
  loadingDealList: true,
  loadPromoDetails: 0,
  product_id: 0,
  fullRangeLoading: true,
  list: {},
  fullRange: {},
  removedItems: [],
  // isAddToTemplate: false,
}
const DealBuilderReducer = function (state = dealBuilder, action) {
  switch (action.type) {
    case 'ADD_REMOVAL_ITEM':
      return {
        ...state,
        removedItems: [...state.removedItems, action.payload],
      }
    case 'REMOVE_REMOVAL_ITEM':
      return {
        ...state,
        removedItems: state.removedItems.filter((item) => item.id !== action.payload),
      }
    case 'TOGGLE_FULL_RANGE_LOADING': {
      return {
        ...state,
        fullRangeLoading: action.value,
      }
    }
    case 'TOGGLE_DEAL_BUILDER_LOADING': {
      return {
        ...state,
        loading: action.value,
      }
    }
    case 'TOGGLE_DEAL_BUILDER_AVAILABLE': {
      return {
        ...state,
        isDealAvailable: action.value,
      }
    }
    case 'TOGGLE_DEAL_BUILDER_LIST_LOADING': {
      return {
        ...state,
        loadingDealList: action.value,
      }
    }
    case 'SIGNAL_PROMODEAL_COMPLETE': {
      return {
        ...state,
        loadPromoDetails: action.value,
      }
    }
    case 'SET_DEAL_BUILDER': {
      return {
        ...state,
        list: action.list,
      }
    }
    case 'SET_DEAL_BUILDER_PRODUCT_ID': {
      return {
        ...state,
        product_id: action.product_id,
      }
    }
    case 'SET_FULL_RANGE': {
      return {
        ...state,
        fullRange: action.list,
      }
    }
    case 'UPDATE_FULL_RANGE': {
      let newList = {}
      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.fullRange[key], ...value }))
      return {
        ...state,
        fullRange: {
          ...state.fullRange,
          ...newList,
        },
      }
    }
    case 'UPDATE_DEAL_BUILDER': {
      let newList = {}

      Object.entries(action.list).forEach(([key, value]) => (newList[key] = { ...state.list[key], ...value }))

      return {
        ...state,
        list: {
          ...state.list,
          ...newList,
        },
      }
    }

    default: {
      return state
    }
  }
}

export default DealBuilderReducer
